import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { SERVICES, HEADER_IMG } from "../data/site";

export default function Services() {
  return (
    <div data-testid="services-page">
      <PageHeader
        overline="Services"
        title="Full-cycle sourcing."
        subtitle="Ten core capabilities covering every stage of procurement — from identifying the right supplier to delivering to your door."
        bgImage={HEADER_IMG.services}
      />

      <section className="max-w-[1440px] mx-auto px-5 sm:px-8 py-24 md:py-32">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-border border border-border">
          {SERVICES.map((s, i) => (
            <Reveal key={s.title} delay={(i % 3) * 0.06} className="bg-card p-8 md:p-10 group hover:bg-secondary transition-colors relative">
              <div className="flex items-start justify-between mb-8">
                <span className="h-12 w-12 bg-brand-orange grid place-items-center">
                  <s.icon size={22} className="text-white" strokeWidth={1.6} />
                </span>
                <span className="font-mono text-border text-2xl font-bold group-hover:text-brand-orange transition-colors">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <h3 className="font-display font-bold text-2xl mb-3">{s.title}</h3>
              <p className="text-muted-foreground leading-relaxed">{s.desc}</p>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-navy text-white py-20 md:py-28">
        <div className="max-w-[1440px] mx-auto px-5 sm:px-8 flex flex-col md:flex-row items-center justify-between gap-8">
          <h2 className="font-display font-black text-3xl md:text-5xl tracking-tight max-w-2xl">One partner for sourcing, quality and export — end to end.</h2>
          <Link to="/quote" className="inline-flex items-center gap-2 bg-brand-orange px-8 py-4 font-mono uppercase text-[11px] tracking-[0.18em] hover:bg-brand-orangeHover transition-colors whitespace-nowrap">
            Request a Quote <ArrowUpRight size={16} />
          </Link>
        </div>
      </section>
    </div>
  );
}
